import type { WidgetConfig } from '@digital-cs/shared';
import { digitalEntryReady } from '../store/widget-store';
import { resolveDigitalPosterUrl } from './oss-poster';

/** 预载看门狗(毫秒):OSS 挂起、onload/onerror 均不回调时强制放开口入口,入口永不锁死 */
const PRELOAD_WATCHDOG_MS = 8000;

interface ImgLike {
  src: string;
  fetchPriority?: string;
  onload: (() => void) | null;
  onerror: (() => void) | null;
}

/**
 * 数字人海报启动预载:config 就绪即 fire-and-forget 拉首帧图,提前焐热
 * OSS 转码缓存 → CDN → 浏览器 HTTP 缓存,用户点开弹窗时海报秒出、无白屏窗口。
 *
 * 落定语义:onload / onerror / 看门狗任一触发即置 digitalEntryReady=true,
 * 悬浮球入口此刻才显示;预载失败(网络挂/403)同样放行,入口不被锁死。
 * 已就绪后重复调用直接返回(bootstrap 幂等)。
 * createImg 仅测试注入用。
 */
export function preloadDigitalPoster(
  cfg: WidgetConfig,
  createImg: () => ImgLike = () => new Image() as unknown as ImgLike,
): void {
  if (digitalEntryReady.value) return;
  const url = resolveDigitalPosterUrl(cfg);
  if (!url) {
    digitalEntryReady.value = true;
    return;
  }
  const img = createImg();
  const settle = () => {
    clearTimeout(watchdog);
    digitalEntryReady.value = true;
  };
  img.onload = settle;
  img.onerror = settle;
  img.fetchPriority = 'high';
  img.src = url;
  const watchdog = setTimeout(() => {
    digitalEntryReady.value = true;
  }, PRELOAD_WATCHDOG_MS);
}
